import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default class ModalPaymentHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            paymentDetail: null,
            typeSelect: null
        }
    }

    componentDidMount() {
        $('#modalPaymentHistory').on('hidden.bs.modal', () => {
            this.setState({
                paymentDetail: null,
                typeSelect: null
            });
        });
    }

    componentWillUnmount() {
        $('#modalPaymentHistory').off('hidden.bs.modal');
    }

    componentWillReceiveProps(nextProps) {
        const icoinPlusId = nextProps.icoinPlusId;
        const typeSelected = nextProps.typeSelected;
        const gameId = nextProps.gameId;
        const id = nextProps.id;
        const json = {
            id: Number(icoinPlusId),
            type: typeSelected
        }

        if (icoinPlusId) {
            if (typeSelected == "FISHHUNTER") {
                axios.post(global.config.apiDomain + '/game/web/payment-details', json, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => {
                    console.log(res.data);
                    this.setState({
                        paymentDetail: res.data,
                        typeSelect: typeSelected
                    })
                }, err => {
                    toast.error(err);
                });
            } else if (typeSelected == "BETTING") {
                axios.post(global.config.apiDomain + '/game/web/payment-details', json, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => {
                    console.log(res.data);
                    this.setState({
                        paymentDetail: res.data,
                        typeSelect: typeSelected
                    })
                }, err => {
                    toast.error(err);
                });
            } else if (typeSelected == "CRAB_GOURD") {
                json.gameId = gameId;
                json.userId = id;
                axios.post(global.config.apiDomain + '/game/web/payment-details', json, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => {
                    console.log(res.data);
                    this.setState({
                        paymentDetail: res.data,
                        typeSelect: typeSelected
                    })
                }, err => {
                    toast.error(err);
                });
            } else {
                axios.post(global.config.apiDomain + '/rest/admin/getPaymentDetail', json,
                    {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => {
                    console.log(res.data);
                    this.setState({
                        paymentDetail: res.data,
                        typeSelect: typeSelected
                    })
                }, err => {
                    toast.error(err);
                });
            }
        }
    }


    formatDateTime(value) {
        if (!value) return "";
        return new Date(value).toLocaleString('vi-VN');
    }

    formatNumber(value) {
        if (value === null || value === undefined || value === "") return "";
        return Number(value).toLocaleString('vi-VN');
    }

    getTitleTargetUser(type) {
        switch (type) {
            case 'TRANSFERTO':
                return "Sender"
            case 'TRANSFERFROM':
                return "Receiver"
            default:
                return "Receiver"
        }
    }

    render() {
        const { paymentDetail, typeSelect } = this.state;

        return (
            <div>
                <div className="modal fade" id="modalPaymentHistory" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Lịch sử chi tiết</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {typeSelect === "CRAB_GOURD" && paymentDetail && (
                                    <>
                                        <h3>Thông tin đặt cược</h3>
                                        <table className="table table-bordered">
                                            <tbody>
                                                <tr>
                                                    <th>Cua</th>
                                                    <td>{paymentDetail.crab}</td>
                                                </tr>
                                                <tr>
                                                    <th>Bầu</th>
                                                    <td>{paymentDetail.gourd}</td>
                                                </tr>
                                                <tr>
                                                    <th>Tôm</th>
                                                    <td>{paymentDetail.shrimp}</td>
                                                </tr>
                                                <tr>
                                                    <th>Nai</th>
                                                    <td>{paymentDetail.deer}</td>
                                                </tr>
                                                <tr>
                                                    <th>Cá</th>
                                                    <td>{paymentDetail.fish}</td>
                                                </tr>
                                                <tr>
                                                    <th>Gà</th>
                                                    <td>{paymentDetail.rooster}</td>
                                                </tr>
                                                <tr>
                                                    <th>Kết quả</th>
                                                    <td>{paymentDetail.result.join(", ")}</td>
                                                </tr>
                                                <tr>
                                                    <th>Icoin thắng</th>
                                                    <td>{paymentDetail.icoinResult}</td>
                                                </tr>
                                                <tr>
                                                    <th>Jackpot</th>
                                                    <td>{paymentDetail.jackpot}</td>
                                                </tr>
                                                <tr>
                                                    <th>Kết quả Jackpot</th>
                                                    <td>{paymentDetail.jackpotResult}</td>
                                                </tr>
                                                <tr>
                                                    <th>Hũ Jackpot</th>
                                                    <td>{paymentDetail.jackpotValue}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </>
                                )}
                                {typeSelect === "FISHHUNTER" && paymentDetail && (
                                    <>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Thời gian</th>
                                                    <th>Icoin</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paymentDetail.details.map((detail, index) => (
                                                    <tr key={index}>
                                                        <td>{new Date(detail.logTime).toLocaleString('vi-VN')}</td>
                                                        <td>{detail.icoin > 0 ? `+${detail.icoin}` : detail.icoin}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                                )}
                                {typeSelect === "BETTING" && paymentDetail && (
                                    <>
                                        <h3>Thông tin đặt cược</h3>
                                        <table className="table table-bordered">
                                            <tbody>
                                                <tr>
                                                    <th>Xúc xắc 1</th>
                                                    <td>{paymentDetail.dice1}</td>
                                                </tr>
                                                <tr>
                                                    <th>Xúc xắc 2</th>
                                                    <td>{paymentDetail.dice2}</td>
                                                </tr>
                                                <tr>
                                                    <th>Xúc xắc 3</th>
                                                    <td>{paymentDetail.dice3}</td>
                                                </tr>
                                                <tr>
                                                    <th>Kết quả</th>
                                                    <td>{paymentDetail.result}</td>
                                                </tr>
                                                <tr>
                                                    <th>Icoin thắng</th>
                                                    <td>{paymentDetail.icoinResult}</td>
                                                </tr>
                                                <tr>
                                                    <th>Icoin đặt lớn</th>
                                                    <td>{paymentDetail.icoinBig}</td>
                                                </tr>
                                                <tr>
                                                    <th>Icoin đặt nhỏ</th>
                                                    <td>{paymentDetail.icoinSmall}</td>
                                                </tr>
                                                <tr>
                                                    <th>Icoin đặt triple</th>
                                                    <td>{paymentDetail.icoinTriple}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </>
                                )}
                                {typeSelect === "PAYPAL" && paymentDetail && (
                                    <>
                                        <h3>Giao dịch PayPal</h3>
                                        <table className="table table-bordered">
                                            <tbody>
                                                {paymentDetail.orderId && (
                                                    <tr>
                                                        <th>Mã đơn PayPal</th>
                                                        <td>{paymentDetail.orderId}</td>
                                                    </tr>
                                                )}
                                                <tr>
                                                    <th>Transaction ID</th>
                                                    <td>{paymentDetail.transactionId || "Không có"}</td>
                                                </tr>
                                                <tr>
                                                    <th>Thời gian cộng icoin</th>
                                                    <td>{this.formatDateTime(paymentDetail.addTime)}</td>
                                                </tr>
                                                {paymentDetail.payTime && (
                                                    <tr>
                                                        <th>Thời gian giao dịch PayPal</th>
                                                        <td>{this.formatDateTime(paymentDetail.payTime)}</td>
                                                    </tr>
                                                )}
                                                <tr>
                                                    <th>Trạng thái</th>
                                                    <td>{paymentDetail.status}</td>
                                                </tr>
                                                {paymentDetail.paymentStatus && (
                                                    <tr>
                                                        <th>Trạng thái phía PayPal</th>
                                                        <td>{paymentDetail.paymentStatus}</td>
                                                    </tr>
                                                )}
                                                <tr>
                                                    <th>Icoin đã cộng</th>
                                                    <td>{paymentDetail.newIcoin > 0 ? `+${this.formatNumber(paymentDetail.newIcoin)}` : this.formatNumber(paymentDetail.newIcoin)}</td>
                                                </tr>
                                                <tr>
                                                    <th>Số dư trước GD</th>
                                                    <td>{this.formatNumber(paymentDetail.oldIcoin)}</td>
                                                </tr>
                                                <tr>
                                                    <th>Số dư sau GD</th>
                                                    <td>{this.formatNumber(paymentDetail.totalIcoin)}</td>
                                                </tr>
                                                {paymentDetail.amount && (
                                                    <tr>
                                                        <th>Số tiền</th>
                                                        <td>{paymentDetail.amount}</td>
                                                    </tr>
                                                )}
                                                {paymentDetail.money > 0 && (
                                                    <tr>
                                                        <th>Quy đổi (VNĐ)</th>
                                                        <td>{this.formatNumber(paymentDetail.money)}</td>
                                                    </tr>
                                                )}
                                                {paymentDetail.payerEmail && (
                                                    <tr>
                                                        <th>Email thanh toán</th>
                                                        <td>{paymentDetail.payerEmail}</td>
                                                    </tr>
                                                )}
                                                {paymentDetail.note && (
                                                    <tr>
                                                        <th>Nội dung</th>
                                                        <td>{paymentDetail.note}</td>
                                                    </tr>
                                                )}
                                                {paymentDetail.reason && (
                                                    <tr>
                                                        <th>Lí do</th>
                                                        <td>{paymentDetail.reason}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {paymentDetail.user && (
                                            <>
                                                <h3>Người nhận icoin</h3>
                                                <ol>
                                                    <li>FacebookID: {paymentDetail.user.facebookId}</li>
                                                    <li>UID: {paymentDetail.user.uid}</li>
                                                    <li>Name: {paymentDetail.user.name}</li>
                                                    <li>Avatar: <img src={paymentDetail.user.profileImageLink} height={50} width={50} alt="avatar" /></li>
                                                </ol>
                                            </>
                                        )}
                                    </>
                                )}
                                {paymentDetail && !["FISHHUNTER", "BETTING", "CRAB_GOURD", "PAYPAL"].includes(typeSelect) && (
                                    <div>
                                        <h3>{typeSelect && typeSelect === "RENEWLIVEROOM" ? "Payer" : "Owner"}</h3>
                                        <ol>
                                            <li>FacebookID: {paymentDetail.user.facebookId}</li>
                                            <li>DeviceID: {paymentDetail.deviceId}</li>
                                            <li>UID: {paymentDetail.user.uid}</li>
                                            <li>Name: {paymentDetail.user.name}</li>
                                            <li>Avatar: <img src={paymentDetail.user.profileImageLink} height={50} width={50} alt="avatar" /></li>
                                        </ol>
                                        {paymentDetail.targetUser && (
                                            <>
                                                <h3>{this.getTitleTargetUser(paymentDetail.type)}</h3>
                                                <ol>
                                                    <li>FacebookID: {paymentDetail.targetUser.facebookId}</li>
                                                    <li>UID: {paymentDetail.targetUser.uid}</li>
                                                    <li>Name: {paymentDetail.targetUser.name}</li>
                                                    <li>Avatar: <img src={paymentDetail.targetUser.profileImageLink} height={50} width={50} alt="avatar" /></li>
                                                </ol>
                                            </>
                                        )}
                                        {paymentDetail.gift && (
                                            <>
                                                <h3>{typeSelect === "TREASURE" ? "Quà mở rương" : "Gift"}</h3>
                                                <ol>
                                                    <li>ID: {paymentDetail.gift.id}</li>
                                                    <li>Name: {paymentDetail.gift.name}</li>
                                                    <li>BuyPrice: {paymentDetail.gift.buyPrice}</li>
                                                    <li>SellPrice: {paymentDetail.gift.sellPrice}</li>
                                                    <li>NoItem: {paymentDetail.gift.noItem}</li>
                                                    <li>Img: <img src={paymentDetail.gift.url} height={50} width={50} alt="gift" /></li>
                                                </ol>
                                            </>
                                        )}
                                        {typeSelect === "TREASURE" && (
                                            <>
                                                <h3>Rương</h3>
                                                {paymentDetail.treasure ? (
                                                    <ol>
                                                        <li>ID: {paymentDetail.treasure.id}</li>
                                                        <li>Name: {paymentDetail.treasure.name}</li>
                                                        <li>BuyPrice: {paymentDetail.treasure.buyPrice}</li>
                                                        <li>SellPrice: {paymentDetail.treasure.sellPrice}</li>
                                                        <li>NoItem: {paymentDetail.treasure.noItem}</li>
                                                        <li>Img: <img src={paymentDetail.treasure.url} height={50} width={50} alt="treasure" /></li>
                                                    </ol>
                                                ) : (
                                                    <p style={{color: '#666', fontStyle: 'italic'}}>Chưa mở rương</p>
                                                )}
                                            </>
                                        )}
                                        {paymentDetail.luckyGift && (
                                            <>
                                                <h3>LuckyGift</h3>
                                                <ol>
                                                    <li>ID: {paymentDetail.luckyGift.id}</li>
                                                    <li>Name: {paymentDetail.luckyGift.name}</li>
                                                    <li>BuyPrice: {paymentDetail.luckyGift.buyPrice}</li>
                                                </ol>
                                            </>
                                        )}
                                        {paymentDetail.recording && (
                                            <>
                                                <h3>Recording</h3>
                                                <ol>
                                                    <li>ID: {paymentDetail.recording._id}</li>
                                                    <li>Name: {paymentDetail.recording.yourName}</li>
                                                    <li>URL: <a href={paymentDetail.recording.onlineRecordingUrl}>{paymentDetail.recording.yourName}</a></li>
                                                </ol>
                                            </>
                                        )}
                                        {paymentDetail.liveRoom && (
                                            <>
                                                <h3>LiveRoom</h3>
                                                <ol>
                                                    <li>ID: {paymentDetail.liveRoom.id}</li>
                                                    <li>UID: {paymentDetail.liveRoom.uid}</li>
                                                    <li>Name: {paymentDetail.liveRoom.name}</li>
                                                    <li>Img: <img src={paymentDetail.liveRoom.thumbnail} height={50} width={50} alt="room" /></li>
                                                </ol>
                                            </>
                                        )}
                                        {paymentDetail.reason && (
                                            <>
                                                <h3>Lí do</h3>
                                                <p>{paymentDetail.reason}</p>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}